import { CommonModule } from '@angular/common';
import { Component, inject, input, InputSignal } from '@angular/core';
import { ColorDirective, DCIcon, IconComponent, TypographyDirective } from '@dartcounter/ui';
import { PartyGamesSettingsService } from 'src/app/modules/games/party-games/services/party-games-settings.service';
import { PartyGameModeTheme } from 'src/app/modules/local-games/themes/game-mode.theme';
import { BannerPatternComponent } from 'src/app/shared/components/banner-pattern/banner-pattern.component';
import { IconBadgeComponent } from 'src/app/shared/components/icon-badge/icon-badge.component';
import { PageLayoutComponent } from 'src/app/shared/components/page-layout/page-layout.component';

@Component({
    selector: 'app-party-game-splash-screen',
    standalone: true,
    imports: [
        CommonModule,
        PageLayoutComponent,
        BannerPatternComponent,
        IconBadgeComponent,
        IconComponent,
        ColorDirective,
        TypographyDirective,
    ],
    templateUrl: './party-game-splash-screen.component.html',
    styleUrl: './party-game-splash-screen.component.css',
    host: {
        class: 'block h-full overflow-x-clip',
    },
})
export class PartyGameSplashScreenComponent {
    public title: InputSignal<string> = input.required();
    public theme: InputSignal<PartyGameModeTheme> = input.required<PartyGameModeTheme>();
    public badgeIcon: InputSignal<DCIcon | null> = input(null);
    private partyGamesSettingsService = inject(PartyGamesSettingsService);
    public backgroundAnimationEnabled = this.partyGamesSettingsService.backgroundAnimationEnabled;
}
